/* get-chat-item-icon.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._lcxvglyw%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1osq%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswstnw%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1dy8%7Bbackground-color%3Avar(--ds-background-accent-blue-subtler%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bv1b66%7Bpadding-left%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3td1b66%7Bpadding-bottom%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f31b66%7Bpadding-right%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0q1b66%7Bpadding-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhki8nm%7Bbackground-color%3Avar(--ds-background-neutral%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1rr0%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
import React from 'react';
import { cx } from '@atlaskit/css';
import type { IconSize } from '@atlaskit/icon';
import TelescopeIcon from '@atlaskit/icon-lab/core/telescope';
import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import GlobeIcon from '@atlaskit/icon/core/globe';
import { Box } from '@atlaskit/primitives/compiled';
import type { Size as SpinnerSize } from '@atlaskit/spinner';
import type { Conversation } from '../../../types';
import ColorfulSpinner from '../../colorful-spinner';
const styles = {
  relativePosition: "_kqswh2mm",
  iconContainerStyles: "_2rko1rr0 _bfhki8nm _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
  iconContainerStylesSelected: "_bfhk1dy8",
  spinnerContainer: "_kqswstnw _1bsb1osq _4t3i1osq _lcxvglyw _1e0c1txw _4cvr1h6o _1bah1h6o"
};
export function getChatItemIcon({
  conversation,
  iconSize = 'medium',
  loading = false,
  isSpinnerOverlayConversationIconEnabled,
  selected = false
}: {
  conversation: Conversation;
  iconSize?: IconSize;
  loading?: boolean;
  isSpinnerOverlayConversationIconEnabled?: boolean;
  selected?: boolean;
}): React.JSX.Element {
  let Icon = AiChatIcon;
  if (conversation.lastMessageType?.includes('DEEP_RESEARCH')) {
    Icon = TelescopeIcon;
  } else if (conversation.lastMessageType?.includes('WEB_SEARCH')) {
    Icon = GlobeIcon;
  }
  const spinnerSizeMap: Record<IconSize, SpinnerSize> = {
    small: 'medium',
    medium: 32
  };
  return <Box xcss={styles.relativePosition}>
			{isSpinnerOverlayConversationIconEnabled && loading && <Box xcss={styles.spinnerContainer}>
					<ColorfulSpinner size={spinnerSizeMap[iconSize]} />
				</Box>}
			<Box xcss={cx(styles.iconContainerStyles, selected && styles.iconContainerStylesSelected)}>
				<Icon spacing="spacious" size={iconSize} label="" />
			</Box>
		</Box>;
}